import { connect } from 'react-redux';
import { selectors as staffSelectors } from 'ducks/staff';

import LoadCreditNotesDialog from './LoadCreditNotesDialog';
import { IApplicationState } from 'ducks/reducers';

const mapStateToProps = (state: IApplicationState) => ({
    staff: staffSelectors.staff(state),
});

export default connect(mapStateToProps, null)(LoadCreditNotesDialog);
